// Faq JS
var faqButtons = document.querySelectorAll(".block__tabs_title");
faqButtons.forEach(function (button) {
  button.addEventListener("click", function () {
    const slideElement = button.closest(".block__faq-slide");
    const sliderContainer = slideElement.closest(".faq_content_row");

    if (slideElement.classList.contains("change_icon")) {
      slideElement.querySelector(".block__faq-panel").style.display = "none";
      slideElement.classList.remove("change_icon");
    } else {
      sliderContainer.querySelectorAll(".block__faq-panel").forEach((panel) => {
        panel.style.display = "none";
      });
      sliderContainer.querySelectorAll(".block__faq-slide").forEach((slide) => {
        slide.classList.remove("change_icon");
      });
      slideElement.querySelector(".block__faq-panel").style.display = "block";
      slideElement.classList.add("change_icon");
    }
  });
});

// Click Event Listener for FAQ Heading
document.addEventListener("click", function (event) {
  const heading = event.target.closest(".js_faq_heading");
  if (heading) {
    const dataId = heading.getAttribute("data_id");

    // Remove active class from all headings
    document.querySelectorAll(".js_faq_heading").forEach((h) => {
      h.classList.remove("active");
    });
    heading.classList.add("active");

    const targetBlock = document.querySelector(`.block__faq-list-wrapper#${dataId}`);
    if (targetBlock) {
      const mobileOffset = window.innerWidth < 991 ? 80 : 100;
      const rect = targetBlock.getBoundingClientRect();
      const offsetPosition = rect.top + window.pageYOffset - mobileOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  }
});

// Check if there are FAQ headings
if (document.querySelector(".js_faq_heading")) {
  let lastId;
  const menuItems = document.querySelectorAll(".block__faq-list-wrapper");
  const scrollItems = Array.from(menuItems);
  window.addEventListener("scroll", function () {
    const headerHeight = document.querySelector(".header").offsetHeight || 0;
    const windowHeight = window.innerHeight;
    const halfWindowHeight = windowHeight / 4;
    const fromTop = window.scrollY + headerHeight - halfWindowHeight;
    const current = scrollItems.filter((item) => item.offsetTop < fromTop);
    const cur = current[current.length - 1];
    const id = cur ? cur.id : "";
    if (lastId !== id) {
      lastId = id;
      if (cur) {
        const dataId = cur.id;
        document.querySelectorAll(".js_faq_heading").forEach((heading) => {
          heading.classList.remove("active");
        });
        const activeHeading = document.querySelector(
          `.js_faq_heading[data_id='${dataId}']`
        );
        if (activeHeading) {
          activeHeading.classList.add("active");
          var htmlContent = activeHeading.innerHTML;
          document.querySelector(".faq_type").innerHTML = htmlContent;
        }
      }
    }
  });
}

(function() {
  const faqSections = Array.from(document.querySelectorAll(".block__faq-list-wrapper"));
  const faqHeadings = document.querySelectorAll(".js_faq_heading");
  const mobileDropdown = document.querySelector(".faq_type");
  const faqBar = document.querySelector(".block__faq-type-list-inner");

  if (!faqSections.length || !faqHeadings.length || !faqBar || !mobileDropdown) return;

  let lastId = null;

  function updateActiveTab() {
    const scrollPos = window.scrollY + 100; // header offset
    const currentSection = faqSections.filter(section => section.offsetTop <= scrollPos).pop();
    if (!currentSection) return;

    const currentId = currentSection.id;
    if (lastId === currentId) return;
    lastId = currentId;

    // Remove active class from all headings
    faqHeadings.forEach(h => h.classList.remove("active"));

    // Add active class to current heading
    const activeHeading = document.querySelector(`.js_faq_heading[data_id='${currentId}']`);
    if (activeHeading) activeHeading.classList.add("active");

    // Update mobile dropdown text
    mobileDropdown.innerHTML = activeHeading.innerHTML;

    // Scroll horizontal bar to keep active heading visible
    const headingOffset = activeHeading.offsetLeft - faqBar.offsetLeft - faqBar.clientWidth / 2 + activeHeading.clientWidth / 2;
    faqBar.scrollTo({
      left: headingOffset,
      behavior: "smooth"
    });
  }

  // Run on scroll
  window.addEventListener("scroll", updateActiveTab);
  // Run once on load
  updateActiveTab();

  // Optional: click on horizontal tabs scroll to section
  faqHeadings.forEach(heading => {
    heading.addEventListener("click", function() {
      const targetId = this.dataset.id;
      const targetSection = document.getElementById(targetId);
      if (!targetSection) return;
      const offset = window.innerWidth < 991 ? 80 : 100; // mobile vs desktop offset
      const topPos = targetSection.offsetTop - offset;
      window.scrollTo({
        top: topPos,
        behavior: "smooth"
      });
    });
  });
})();
